import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import { TenantBaseInfoResponse } from '../../../../api/cc-tenant';
import { Button, Form, InputNumber, Modal } from '@maxtropy/components';
import { apiV2UnitConsumptionConfigDetailPost, apiV2UnitConsumptionConfigSavePost } from '@maxtropy/tody-mgmt-apis-v2';
import { isNil } from 'lodash-es';

interface BaseConfigProps {
  tenant?: TenantBaseInfoResponse;
  disabled?: boolean;
}

const BaseConfig: FC<BaseConfigProps> = props => {
  const { tenant, disabled = false } = props;
  const [opened, setOpened] = useState(false);
  const [form] = Form.useForm();
  const [configId, setConfigId] = useState<number>();

  useEffect(() => {
    if (tenant?.mcid) {
      apiV2UnitConsumptionConfigDetailPost({ tenantMcid: tenant?.mcid }).then(res => {
        setConfigId(res.id);
        form.setFieldsValue({
          consumption: res.consumption,
          consumption1: res.consumption1,
          consumption2: res.consumption2,
          consumption3: res.consumption3,
        });
      });
    }
  }, [tenant]);

  const onOpen = () => {
    setOpened(true);
  };

  const onOk = () => {
    form.validateFields().then(values => {
      if (isNil(tenant?.mcid)) return;
      apiV2UnitConsumptionConfigSavePost({
        id: configId,
        tenantMcId: tenant?.mcid,
        consumption: values.consumption,
        consumption1: values.consumption1,
        consumption2: values.consumption2,
        consumption3: values.consumption3,
      }).then(res => {
        setConfigId(res?.id);
        setOpened(false);
      });
    });
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Button disabled={disabled} type="dashed" icon={<PlusOutlined />} onClick={onOpen}>
        基准值设置
      </Button>
      <Modal
        title="基准值设置"
        open={opened}
        onOk={onOk}
        onCancel={() => {
          setOpened(false);
        }}
      >
        <Form form={form}>
          <Form.Item label="平台门户" name="consumption">
            <InputNumber style={{ width: 220 }} placeholder="请输入" addonAfter={'tCO₂e/tce'} />
          </Form.Item>
          <Form.Item label="总览-1" name="consumption1">
            <InputNumber style={{ width: 220 }} placeholder="请输入" addonAfter={'tCO₂e/tce'} />
          </Form.Item>
          <Form.Item label="总览-2" name="consumption2">
            <InputNumber style={{ width: 220 }} placeholder="请输入" addonAfter={'tCO₂e/tce'} />
          </Form.Item>
          <Form.Item label="总览-3" name="consumption3">
            <InputNumber style={{ width: 220 }} placeholder="请输入" addonAfter={'tCO₂e/tce'} />
          </Form.Item>
        </Form>
      </Modal>
    </Space>
  );
};

export default BaseConfig;
